<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("report_by_product") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
                        <div class="form-group row">
                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        class="form-control datepicker"
                                        v-model="startDate"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        class="form-control datepicker"
                                        v-model="endDate"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="platform_id"
                                        :placeholder="$t('platform')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PlatformTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

                            <div class="col-md-5 ">
                                <base-button
                                    size="md"
                                    type="primary"
                                    @click="handleSearch()"
                                >
                                    Search
                                </base-button>
                                <base-button
                                    size="md"
                                    type="primary"
                                    @click="handleDownloadXLSX()"
                                >
                                    Export
                                </base-button>
                                <base-button
                                    size="md"
                                    type="primary"
                                    @click="handleDownloadXLSXPowerBI()"
									v-if="searchDate != '' && searchPlatform == 0 "
                                >
                                    Export PowerBI
                                </base-button>
                            </div>
                        </div>
                    </template>
                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                            @sort-change="sortChange"
                            @selection-change="selectionChange"
                        >
                            <el-table-column
                                v-for="column in tableColumns"
                                :key="column.label"
                                v-bind="column"
                            >
                            </el-table-column>

                            <!-- <el-table-column
				  min-width="200px"
				  align="right"
				  :label="$t('actions')"
				>
				  <div slot-scope="{ $index, row }" class="d-flex">
					<base-button
					  @click.native="handleDetail($index, row)"
					  class="edit"
					  type="warning"
					  size="sm"
					  icon
					>
					  <i class="text-dtac-bt fa fa-edit"></i>
					  Detail
					</base-button>
				  </div>
				</el-table-column> -->
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class=" col-12 d-flex justify-content-center justify-content-sm-between flex-wrap "
                        v-if="tableData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { read, utils, writeFile } from "xlsx";

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableDataOrg: "Report/getReportSaleChannelProduct",
            SaleChannelTypeTableWithAll: "SaleChannel/getDataTypeWithAll",
            PlatformTable: "Order/getPlatformTableWithAll",
            OrderStatusTable: "Order/OrderStatusTableWithAll"
        }),
		tableData() {
			let data = []
			this.tableDataOrg.forEach(item => {
				let platform_name = item.platform_name;
				let platform_id = item.platform_id;

				item.sale_channels_and_details.forEach(sale_channel => {

					sale_channel.products_and_promotions.forEach(product => {
						data.push({
							platform_id	: platform_id,
							platform_name: platform_name,
							sale_channel_id: sale_channel.sale_channel_id,
							sale_channel_name: sale_channel.sale_channel_name,
							product_name: product.product_name,
							product_id: product.product_id,
							// sum_sale_price: product.sum_sale_price,
							// sum_cost: product.sum_cost,
							// sum_shipping_cost: product.sum_shipping_cost,
							// per_each_cost: product.per_each_cost,
							// per_each_promotion_price: product.per_each_promotion_price,
							// sale_amount: product.sale_amount,
							// profit: product.sum_sale_price - product.sum_cost - product.sum_shipping_cost

							sum_sale_price: this.formatPrice(product.sum_sale_price),
							sum_cost: this.formatPrice(product.sum_cost),
							sum_shipping_cost: this.formatPrice(product.sum_shipping_cost),
							per_each_cost: this.formatPrice(product.per_each_cost),
							per_each_promotion_price: this.formatPrice(product.per_each_promotion_price),
							sale_amount: product.sale_amount, // Assuming sale_amount is a quantity and not a price
							profit: this.formatPrice(product.sum_sale_price - product.sum_cost - product.sum_shipping_cost)
						});
					});
				});
			});

			return data
		},
        tableColumns: function() {
            return [
                {
                    prop: "platform_name",
                    label: "Platform",
                    minWidth: 80,
                    sortable: true
                },
				{
                    prop: "sale_channel_name",
                    label: this.$t("sale_channel_name"),
                    minWidth: 200,
                    sortable: true
                },
                {
                    prop: "product_name",
                    label: this.$t("product_promotion"),
                    minWidth: 400,
                    sortable: true
                },
				{
                    prop: "sum_sale_price",
                    label: this.$t("sum_sale_price"),
                    minWidth: 100,
                    sortable: true
                },
                {
                    prop: "sum_cost",
                    label: this.$t("sum_cost"),
                    minWidth: 80,
                    sortable: true
                },
                {
                    prop: "sum_shipping_cost",
                    label: this.$t("sum_shipping_cost"),
                    minWidth: 80,
                    sortable: true
                },
                {
                    prop: "per_each_cost",
                    label: this.$t("per_each_cost"),
                    minWidth: 80,
                    sortable: true
                },
                {
                    prop: "per_each_promotion_price",
                    label: this.$t("per_each_promotion_price"),
                    minWidth: 80,
                    sortable: true
                },
                {
                    prop: "sale_amount",
                    label: this.$t("sale_amount"),
                    minWidth: 100,
                    sortable: 80
                },
                {
                    prop: "profit",
                    label: this.$t("profit"),
                    minWidth: 100,
                    sortable: 80
                },



            ];
        }
    },
    data() {
        return {
            propsToSearch: ["Name"],
            selectedRows: [],
            SearchData: "",
            startDate: "",
            endDate: "",
            bo_sale_channel_type_id: 0,
            platform_id: 0,
            order_status: 999,
            searchDate: "",
			searchPlatform : 0 ,
        };
    },
    mounted() {
        // this.startDate = moment()
        //     .add(-3, "days")
        //     .format("YYYY-MM-DD");
        this.startDate = moment().subtract(1, 'days').format("YYYY-MM-DD");
        this.endDate = moment().subtract(1, 'days').format("YYYY-MM-DD");
        this.handleSearch();
    },
    methods: {
        ...mapActions({
            listData: "Report/listReportSaleChannelProduct"
        }),
		formatPrice(value){
			 // Check if the value is a decimal
			if (value % 1 !== 0) {
				// If it is a decimal, return with 2 decimal places
				return value.toFixed(2);
			} else {
				// If it is an integer, return as is
				return value;
			}
		},
        async handleSearch() {
			this.searchDate = ""
			this.searchPlatform = this.platform_id
			if (this.startDate == this.endDate) {
				this.searchDate = this.startDate
			}

            let os = [];
            switch (this.order_status) {
                case 0:
                    break;

                case 999:
                    os = [121, 122, 130];
                    break;

                default:
                    os = [this.order_status];
                    break;
            }

            let params = {
                time_from: this.startDate,
                time_to: this.endDate,
                bo_sale_channel_type_id: this.bo_sale_channel_type_id,
                platform_id: this.platform_id,
                order_status: os,
				data_from_order: 1  // Use data from order	
            };
            await this.listData(params);


            // this.sortChange({ prop: "Cnt", order: "desc" });
        },
        async handleDownloadXLSX(index, row) {
            let dataExport = this.tableData.map(item => {
                return {
						platform_id	: item.platform_id,
						product_id: item.product_id,
						sale_channel_id: item.sale_channel_id,
						Platform: item.platform_name,
						"ช่องทางการขาย": item.sale_channel_name,
						"สินค้าและโปรโมชั่น": item.product_name,
						"ยอดขายรวม": item.sum_sale_price,
						"ต้นทุนรวม": item.sum_cost,
						"ค่าขนส่งรวม": item.sum_shipping_cost,
						"ราคาขายต่อหน่วย": item.per_each_promotion_price,
						"ต้นทุนต่อหน่วย": item.per_each_cost,
						"จำนวนที่ขายได้": item.sale_amount,
						"กำไร": item.profit
                };
            });

            const dataWS = utils.json_to_sheet(dataExport);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, dataWS);
            writeFile(wb, `cost_profit_${this.startDate}_${this.endDate}.xlsx`);
        },
		async handleDownloadXLSXPowerBI(index, row) {
            let dataExport = this.tableData.map(item => {
                return {
						date	: this.searchDate,
						platform_id	: item.platform_id,
						product_id: item.product_id,
						sale_channel_id: item.sale_channel_id,
						Platform: item.platform_name,
						"ช่องทางการขาย": item.sale_channel_name,
						"สินค้าและโปรโมชั่น": item.product_name,
						"ยอดขายรวม": item.sum_sale_price,
						"ต้นทุนรวม": item.sum_cost,
						"ค่าขนส่งรวม": item.sum_shipping_cost,
						"ราคาขายต่อหน่วย": item.per_each_promotion_price,
						"ต้นทุนต่อหน่วย": item.per_each_cost,
						"จำนวนที่ขายได้": item.sale_amount,
						"กำไร": item.profit
                };
            });

            const dataWS = utils.json_to_sheet(dataExport);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, dataWS);
            writeFile(wb, `cost_profit_bi_${this.searchDate}.xlsx`);
        },
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        }
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
